import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect } from "@/mixins/index";
import { Message } from "element-ui";
import { addEventMap, updEventMap } from "@/api/dataAll/dataAll";
export default {
  name: "addSentityword",
  mixins: [serchSelect],
  data: function data() {
    return {
      dialogFormVisible: false,
      searchData: {
        id: "",
        event: "",
        func: ''
      },
      rules: {
        func: [{
          required: true,
          message: this.$t('pleaseInputEvent'),
          trigger: "blur"
        }],
        event: [{
          required: true,
          message: this.$t('pleaseInputName'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log(row);
                _this.dialogFormVisible = true;

                if (row) {
                  _this.searchData = _objectSpread({}, row);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm() {
      this.dialogFormVisible = false;
      this.clearData(true);
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      var _this2 = this;

      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          var data = {
            id: _this2.searchData.id,
            game_id: _this2.rawData.game_id,
            func: _this2.searchData.func,
            event: _this2.searchData.event
          };
          var reqFn = _this2.searchData.id ? updEventMap : addEventMap;
          reqFn(data).then(function (res) {
            if (res.status == 200) {
              Message.success(res.message);
              _this2.searchData.id = '';

              _this2.resetForm("ruleForm");

              _this2.$emit("refreshDataList");
            }
          });
        }
      });
    },
    clearData: function clearData(type) {
      this.searchData = {
        id: type ? '' : this.searchData.id,
        sensitive_word: '',
        game: this.searchData.game
      };
      this.$refs.form.resetFields();
    }
  }
};